import React, { useEffect, useState } from "react";

import { fadeMotionProps, pageMotionProps } from "../../utils/styles/animations";

import * as Styled from "./HomePage.styles";
import { APP_EVENTS, EventsManager } from "../../webgl/events/EventsManager";
import useGlobalStore from "utils/store";
import ButtonCta from "components/ButtonCta/ButtonCta";
import { ReactComponent as InstructionsSVG } from "../../svg/instructions-icon.svg";
import ButtonRect from "components/ButtonRect/ButtonRect";
import EventOverlay from "components/EventOverlay/EventOverlay";
import { CameraManager } from "webgl/scenes/CameraManager";
import Features from "components/Features/Features";
import GalleryOverlay from "components/GalleryOverlay/GalleryOverlay";
import { ScenesManager } from "webgl/scenes/ScenesManager";
import PreSaleOverlay from "components/PreSaleOverlay/PreSaleOverlay";
import { COPY } from "data/content";
import { supportedLanguages } from "data/content.types";
// import Counter from "components/Counter/Counter";


const HomePage: React.FunctionComponent = () => {
  const [show, setShow] = useState<boolean>(false);
  const [showFeatures, setShowFeatures] = useState<boolean>(false);
  const [inInterior, setInInterior] = useState<boolean>(false);
  const [PreVendaLabel, setPreVendaLabel] = useState<string>('');
  const [CTALabel, setCTALabel] = useState<string>('');
  const { 
    isLoading, 
    isContentLoaded,
    sceneMounted,
    showUI, 
    copy, 
    isPreEvent, 
    isPreVenda, 
    isCTA, 
    setIsPreVenda, 
    hasAllFeatures, 
    isEventLive, 
    setShowEventOverlay, 
    showEventOverlay, 
    setShowPreSaleOverlay, 
    showPreSaleOverlay, 
    setShowGalleryOverlay, 
    isCountdown,
    showGalleryOverlay } = useGlobalStore();
  
  const goTo = (url) => {
    window.dataLayer.push({
      event: 'vclique_novidades'
    })
   
   
    window.open(url, "_blank");
  };

  const goToPreVenda = (url) => {
    window.dataLayer.push({
      event: 'clique_pre_venda'
    })   
   
    window.open(url, "_blank");
  };

  useEffect(() => {    
    CameraManager.setEnable(!showEventOverlay);
      
    if (isPreVenda) {
      setPreVendaLabel(COPY[supportedLanguages.es].homeScreen.eventCtaPre)
    }

    if (isCTA) {
      setCTALabel(COPY[supportedLanguages.es].homeScreen.learnMoreCta)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAllFeatures, isPreVenda, isCTA])


  useEffect(() => {
    if (showUI && sceneMounted) {
      setTimeout(() => {
        setShow(true);
      }, 4000);
      
      EventsManager.instance.on(APP_EVENTS.APP_HIDE, () => {
        setShow(false);
      });
      
      EventsManager.instance.on(APP_EVENTS.FEATURE_SHOW, () => {
        if (ScenesManager.hasOverlay) return;
        setShowFeatures(true);
      });
      EventsManager.instance.on(APP_EVENTS.FEATURE_HIDE, () => {
        setShowFeatures(false);
      });
    }


    return () => {
      setShow(false);
    };

  }, [isLoading, showUI]);

  return (
    <Styled.Wrapper {...pageMotionProps}>
      {show && (
      <>  
          {!showFeatures && (
            <Styled.ControllerButtonWrapper {...fadeMotionProps}>
              <InstructionsSVG />
              <div className="directionLeft"
                onClick={() => CameraManager.rotate(false, -1)}
              />
              <button className="directionTop" onClick={() => CameraManager.rotate(true, -1)} />
              <button className="directionRight" onClick={() => CameraManager.rotate(false, 1)} />
              <button className="directionBottom" onClick={() => CameraManager.rotate(true, 1)} />
              <button className="zoomIn" onClick={() => CameraManager.zoom(true)} />
              <button className="zoomOut" onClick={() => CameraManager.zoom(false)} />
            </Styled.ControllerButtonWrapper>
          )}
          <Styled.Buttons {...fadeMotionProps}>          
            <Styled.ButtonsTop>
            {isCTA &&
              <ButtonCta
                onAction={() => {
                  const url = COPY[supportedLanguages.es].homeScreen.learnMoreCtaURL;

                    // @ts-ignore
                    if (url.indexOf("api.whatsapp.com") > -1 && window.getGclid() !== null) {
                      // @ts-ignore
                      window.openWhatsApp();
                    } else {
                      goTo(url)
                    }
                }}
                // label={COPY[supportedLanguages.es].homeScreen.learnMoreCta}
                label={CTALabel}
                onDisabled={false}
                fullIcon={false}                
              />
            }
            </Styled.ButtonsTop>
          
            {!showFeatures && (
             <Styled.ButtonsBottom {...fadeMotionProps}>
              {(ScenesManager.TOTAL_FEATURES.internalActive > 0) && 
                <ButtonRect label={inInterior ? copy.homeScreen.exteriorCta : copy.homeScreen.interiorCta} onAction={()=> {
                  EventsManager.instance.trigger(inInterior? APP_EVENTS.INTERIOR_HIDE : APP_EVENTS.INTERIOR_SHOW);
                  
                  if (!inInterior) {
                    window.dataLayer?.push({
                      event: 'clique_interior'
                    })
                  } else {
                    window.dataLayer?.push({
                      event: 'clique_exterior'
                    })
                  }
                  
                  setInInterior(!inInterior)
                }} variant={!inInterior? "interior" : "exterior"} />
              }
              {isPreVenda &&
                <ButtonRect label={PreVendaLabel} onAction={() => goToPreVenda(COPY[supportedLanguages.es].homeScreen.eventCtaPreURL)} variant="event" />
              }
                           
              {(isCountdown && !isPreVenda) &&
               <ButtonRect label={copy.preSale.title} onAction={() => {}} variant="countdown" />
              }
            </Styled.ButtonsBottom>
            
            )}
           
          </Styled.Buttons>
        </>
      )}
      
      {showEventOverlay && <EventOverlay onClose={() => {
        setShowEventOverlay(false);
        ScenesManager.hasOverlay = false;
      }}/>}
      {/* {showPreSaleOverlay && <PreSaleOverlay onClose={() => {
        setShowPreSaleOverlay(false);
        ScenesManager.hasOverlay = false;
        window.dataLayer?.push({
          event: 'clique_pre_venda'
        })
      }}/>} */}
      {showGalleryOverlay && <GalleryOverlay onClose={() => {
        setShowGalleryOverlay(false);
        ScenesManager.hasOverlay = false;
      }}/>}
      {showFeatures && <Features />}
    </Styled.Wrapper>
  );
};

export default HomePage;
